export default ({ request }) => ({
    fabricStockOutDetailListApi(data = {}) {
        return request({
            url: "/digitalCenter/fabricStockOutDetail/list",
            method: "post",
            data,
        });
    },
    fabricStockOutDetailSaveApi(data = {}) {
        return request({
            url: "/digitalCenter/fabricStockOutDetail/save",
            method: "post",
            data,
        });
    },
    fabricStockOutDetailDelApi(data = {}) {
        return request({
            url: "/digitalCenter/fabricStockOutDetail/del",
            method: "post",
            data,
        });
    },
});
